import Hero from "../components/Hero";
import EditorialMarquee from "../components/Marquee";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { MaskLineInView, Reveal } from "../components/Reveal";
import { IMAGES } from "../data/services";

const ARMS = [
  {
    to: "/studios",
    tag: "Creator Hub",
    title: "SEC Studios",
    desc: "Studio hire, streamer tech, custom branding and a turnkey incubator — 100% unbranded space built around your brand.",
    img: IMAGES.mic,
  },
  {
    to: "/collectibles",
    tag: "Premier Card Services",
    title: "The Collectibles",
    desc: "Professional cleaning, group grading to PSA / BGS / CGC, and high-value consignment with fast payouts.",
    img: IMAGES.cardBellingham,
  },
];

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />

      <section className="py-24 sm:py-32 border-t border-[#27272a]">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
          <div className="grid lg:grid-cols-12 gap-8 mb-14">
            <span className="lg:col-span-4 font-mono text-xs uppercase tracking-[0.2em] text-gold">
              [ Two Arms, One Roof ]
            </span>
            <h2 className="lg:col-span-8 font-display text-3xl sm:text-5xl font-semibold tracking-tight leading-[1.02]">
              <MaskLineInView>We treat cardboard like currency</MaskLineInView>
              <MaskLineInView delay={0.08} className="text-zinc-500">and creators like broadcasters.</MaskLineInView>
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-5">
            {ARMS.map((a, i) => (
              <Reveal key={a.to} delay={i * 0.1}>
                <Link
                  to={a.to}
                  className="group relative flex flex-col justify-end min-h-[420px] overflow-hidden border border-[#27272a] hover:border-gold/50 transition-colors duration-500"
                  data-testid={`home-arm-${a.title.toLowerCase().includes("studio") ? "studios" : "collectibles"}`}
                >
                  <div className="absolute inset-0">
                    <img src={a.img} alt={a.title} className="w-full h-full object-cover opacity-45 group-hover:opacity-60 group-hover:scale-105 transition-all duration-700 ease-out" />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-[#0a0a0a]/60 to-[#0a0a0a]/10" />
                  </div>
                  <div className="absolute top-6 left-6 right-6 flex items-start justify-between">
                    <span className="font-mono text-xs uppercase tracking-[0.2em] text-gold">{a.tag}</span>
                    <span className="h-10 w-10 grid place-items-center rounded-full border border-white/20 text-white group-hover:bg-gold group-hover:text-black group-hover:border-gold transition-all duration-300">
                      <ArrowUpRight size={18} />
                    </span>
                  </div>
                  <div className="relative p-7">
                    <h3 className="font-display text-3xl sm:text-4xl font-semibold uppercase tracking-tight">{a.title}</h3>
                    <p className="text-zinc-300 text-sm mt-3 max-w-md leading-relaxed">{a.desc}</p>
                    <span className="mt-5 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.15em] text-white group-hover:text-gold transition-colors">
                      Explore <ArrowUpRight size={14} />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <EditorialMarquee />
    </main>
  );
}
